export default [
    {
        name: 'tours',
        path: '/tours',
    },
    {
        name: 'excursions',
        path: '/excursions',
    },
    {
        name: 'destinations',
        path: '/destinations'
    },
    // {
    //     name: 'accomodation',
    //     path: '/accomodation',
    //     children: [
    //         {
    //             name: 'hotels',
    //             path: '/accomodation/hotels'
    //         },
    //         {
    //             name: 'apartments',
    //             path: '/accomodation/apartments'
    //         }
    //     ],
    //     hidden: true
    // },
    {
        name: 'services',
        path: '/services',
    },
    {
        name: 'blog',
        path: '/blog'
    }
]